import { createFileRoute } from "@tanstack/react-router";
import { SeoPage } from "@/components/SeoPage";
import { faqJsonLd } from "@/lib/seo-jsonld";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { SOURCE_FOHM_VAGLEDNING, SOURCE_ALKOHOLLAGEN, SOURCE_PROP_2025_26, LAST_REVIEWED } from "@/lib/official-sources";

const faqs = [
  { q: "Vem behöver serveringstillstånd?", a: "Den som vill servera spritdrycker, vin, starköl eller andra jästa alkoholdrycker mot ersättning behöver serveringstillstånd från kommunen." },
  { q: "Vad krävs för att få tillstånd?", a: "Personlig och ekonomisk lämplighet, kunskap i alkohollagen (kunskapsprovet) och en lokal som är lämplig från brand- och säkerhetssynpunkt. Från 1 juni 2026 är kraven på matservering och eget kök borttagna, liksom bestämmelserna om sittplatser och drinkbarer. Matservering är inte längre ett villkor för tillståndet." },
  { q: "Hur lång tid tar handläggningen?", a: "Tiden varierar mellan kommuner men typiskt 2–4 månader. Komplett ansökan snabbar upp processen." },
];

export const Route = createFileRoute("/serveringstillstand")({
  component: () => (
    <SeoPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Guider", to: "/serveringstillstand-och-kunskapsprov" },
        { label: "Serveringstillstånd" },
      ]}
      title="Serveringstillstånd – så fungerar det"
      intro="Allt du behöver veta om att ansöka om serveringstillstånd hos kommunen. Uppdaterat för 2026."
      lastReviewed={LAST_REVIEWED}
      sources={[SOURCE_FOHM_VAGLEDNING, SOURCE_ALKOHOLLAGEN, SOURCE_PROP_2025_26]}
      sections={[
        { h2: "Vad är serveringstillstånd?", body: "Serveringstillstånd är ett tillstånd från kommunen som krävs för att få servera alkoholdrycker mot ersättning. Tillståndet regleras av alkohollagen (2010:1622)." },
        { h2: "Krav för att få tillstånd (uppdaterat 2026)", body: "Du måste visa personlig och ekonomisk lämplighet, ha goda kunskaper om alkohollagen (kunskapsprovet) och driva verksamheten i en lokal som är lämplig från brand- och säkerhetssynpunkt med betryggande tillsyn. Från 1 juni 2026 är kraven på matservering och eget kök borttagna, liksom bestämmelserna om sittplatser och drinkbarer. Matservering är inte längre ett villkor för tillståndet." },
        { h2: "Kunskapsprovet", body: "Som del av ansökan genomför du ett skriftligt kunskapsprov i kommunens regi. Provet täcker alkohollagen, serveringsansvar, tillsyn, ålderskontroll, ordning och nykterhet, marknadsföring m.m." },
        { h2: "Hur du förbereder dig", body: "Öva på frågor i Alkoholprovet inom alla 16 områden, gör provsimuleringar och granska dina svaga områden. Vi täcker även nya regler för 2026." },
      ]}
      faqs={faqs}
      related={{
        title: "Relaterade sidor",
        links: [
          { to: "/serveringstillstand-och-kunskapsprov", label: "Hub – alla guider" },
          { to: "/serveringstillstand-stockholm", label: "Serveringstillstånd Stockholm" },
          { to: "/serveringstillstand-goteborg", label: "Serveringstillstånd Göteborg" },
          { to: "/serveringstillstand-malmo", label: "Serveringstillstånd Malmö" },
          { to: "/serveringstillstand-restaurang", label: "För restaurang" },
          { to: "/serveringstillstand-bar", label: "För bar & nattklubb" },
          { to: "/serveringstillstand-cafe", label: "För café" },
          { to: "/serveringstillstand-catering", label: "För catering" },
          { to: "/serveringstillstand-food-truck", label: "För food truck" },
          { to: "/tillfalligt-serveringstillstand", label: "Tillfälligt tillstånd" },
          { to: "/kunskapsprov-alkohollagen", label: "Kunskapsprov i alkohollagen" },
          { to: "/foretag", label: "Företagslösning" },
        ],
      }}
    />
  ),
  head: () => ({
    meta: [
      { title: "Serveringstillstånd 2026 – krav och ansökan" },
      { name: "description", content: "Allt om serveringstillstånd i Sverige 2026. Krav, ansökan, kunskapsprovet och tips för att lyckas." },
      { property: "og:title", content: "Serveringstillstånd 2026 – krav och ansökan" },
      { property: "og:description", content: "Krav, ansökan, kunskapsprov och handläggningstider för serveringstillstånd i Sverige 2026." },
      { property: "og:url", content: "https://alkoholprovet.se/serveringstillstand" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/serveringstillstand" }],
    scripts: [
      faqJsonLd(faqs),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Guider", url: "https://alkoholprovet.se/serveringstillstand-och-kunskapsprov" },
        { label: "Serveringstillstånd", url: "https://alkoholprovet.se/serveringstillstand" },
      ]),
    ],
  }),
});
